import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import SingleBlogPage from './pages/SingleBlogPage';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blogs/:blogId" element={<SingleBlogPage />} />
      </Routes>
    </Router>
  );
}

export default App;
